// extracted by mini-css-extract-plugin
export var buttons = "textTagline-module--buttons--cd184";
export var flag = "textTagline-module--flag--f2e81";
export var grid = "textTagline-module--grid--961ec";
export var headline = "textTagline-module--headline--ea564";
export var subhead = "textTagline-module--subhead--9f818";